module.exports = __webpack_public_path__ + "media/36.411c729f.mp3";